import App from './App.vue';
import { user } from '@/beforeGuard/defaultRules';

export default {
  path: '/CDS_VF_MasterList',
  name: 'CDS_VF_MasterList',
  component: App,
  meta: {
    pageProperty: {
      title: 'マスタ管理',
      controller: 'CDS_CTR_MasterList',
    },
    guardRules: [user],
  },
};
